module.exports = __webpack_public_path__ + "img/map-fill.fdb7b7a3.svg";